import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsMonkeytieComponent } from './simple-icons-monkeytie.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsMonkeytieComponent ],
    exports:      [ SimpleIconsMonkeytieComponent ],
    bootstrap:    []
})
export class SimpleIconsMonkeytieModule {}
